import { ComponentPropsWithoutRef, forwardRef, MouseEventHandler } from 'react';
import {
  NJIconButton,
} from "@engie-group/fluid-design-system-react";
import styles from "./NJChatFeedback.module.css";

/**
 * Interface for chat feedback properties.
 *
 * @interface IChatFeedbackProps
 */
export interface IChatFeedbackProps extends ComponentPropsWithoutRef<'div'> {
  onCopyClicked?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  onRefreshClicked?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  onLikeClicked?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  onDislikeClicked?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
}

export const NJChatFeedback = forwardRef<HTMLDivElement, IChatFeedbackProps>(
  ({ onCopyClicked, onRefreshClicked, onLikeClicked, onDislikeClicked, ...props }, ref) => {

    return (
      <div ref={ref} {...props} className={`
        ${styles["nj-chat-feedback"]} 
        ${props.className} 
        `}>

        {onCopyClicked ? (
          <NJIconButton
            label="Copy"
            title="Copy"
            variant="tertiary"
            size="sm"
            onClick={onCopyClicked}
            icon="content_copy"
          ></NJIconButton>
        ) : null}
        {onRefreshClicked ? (
          <NJIconButton
            label="Refresh"
            title="Refresh"
            variant="tertiary"
            size="sm"
            onClick={onRefreshClicked}
            icon="sync"
          ></NJIconButton>
        ) : null}
        {onLikeClicked ? (
          <NJIconButton
            label="Like"
            title="Like"
            variant="tertiary"
            size="sm"
            onClick={onLikeClicked}
            icon="thumb_up_off_alt"
          ></NJIconButton>
        ) : null}
        {onDislikeClicked ? (
          <NJIconButton
            label="Dislike"
            title="Dislike"
            variant="tertiary"
            size="sm"
            onClick={onDislikeClicked}
            icon="thumb_down_off_alt"
          ></NJIconButton>
        ) : null}
      </div>
    );
  }
);
